import React from 'react';
import Paper from '@material-ui/core/Paper/Paper';
import { isFreePlan } from '../../../../../utils/helper';
import Loading from '../../../../Common/Loading';
import styles from '../styles';

const DataRetentionTile = ({ account, onUpgrade }) => {
  return (<Paper style={styles.dataRetentionContainer}>
    {account ? <div>
      <div style={styles.row}>
        <div style={{ flex: 1 }}>
          <div style={styles.paperTitle}>Data Retention Period</div>
          {isFreePlan(account) ? <div style={styles.paperBody}>14 days</div> :
            <div style={styles.paperBody}>{account.settings ? account.settings.retentionPeriod : 1} <span
              style={styles.month}>month{account.settings && account.settings.retentionPeriod > 1 ? 's' : ''}</span>
            </div>}
        </div>
      </div>
    </div> : <Loading/>}
  </Paper>);
};

export default DataRetentionTile;



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingView/tiles/DataRetentionTile.js